import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from '@unite-us/ui';
import './DeleteButton.scss';
import ToolTip from './ToolTip/ToolTip';
import { isEmpty } from 'lodash';
var ToolTipContent = function ToolTipContent(toolTipText) {
  return /*#__PURE__*/React.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/React.createElement("p", null, toolTipText));
};
var ArchiveIcon = function ArchiveIcon(_ref) {
  var labelText = _ref.labelText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconTrash",
    size: 16,
    ariaLabel: "archive-insurance-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "delete-button__text"
  }, labelText));
};
function DeleteButton(props) {
  var ariaLabel = props.ariaLabel,
    id = props.id,
    labelText = props.labelText,
    onClick = props.onClick,
    toolTipText = props.toolTipText;
  return isEmpty(toolTipText) ? /*#__PURE__*/React.createElement("button", {
    "aria-label": ariaLabel,
    className: "delete-button mt-quarter",
    type: "button",
    title: "Delete insurance",
    id: id,
    onClick: onClick,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(ArchiveIcon, {
    labelText: labelText
  })) : /*#__PURE__*/React.createElement(ToolTip, {
    tooltipContent: ToolTipContent(toolTipText)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mt-1"
  }, /*#__PURE__*/React.createElement(ArchiveIcon, {
    labelText: labelText
  })));
}
DeleteButton.propTypes = {
  ariaLabel: PropTypes.string,
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  toolTipText: PropTypes.string
};
DeleteButton.defaultProps = {
  labelText: 'delete',
  ariaLabel: 'delete',
  toolTipText: ''
};
export default DeleteButton;
//# sourceMappingURL=DeleteButton.js.map